import styled from 'styled-components';
import { marginStyles } from '../../../styles/components.js';

const StyledCardImage = styled.img `
  width: 100%;

  ${props => marginStyles(props.margin)};
`;

export { StyledCardImage };
